
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="12"
				selector
				@change="onViewChange"
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="订单号">
							<c-input name="keyword" placeholder="销售单号/三方订单号"></c-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_info" placeholder="产品名称/背贴码/IMEI"></c-input>
						</m-search-item>
						<m-search-item label="销售渠道">
							<c-select name="channel_id" async @search="searchChannel"></c-select>
						</m-search-item>
						<m-search-item label="发货单号">
							<c-input name="express_no"></c-input>
						</m-search-item>
						<m-search-item label="创建时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_online_order_ship')" prepend-icon="tf-batch" @click="batchGenerateDelivery()">批量生成发货单</c-button>
<!--					<c-button prepend-icon="tf-batch" @click="batchGenerateDelivery()">批量生成发货单</c-button>-->
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_online_order_ship')" color="main" prepend-icon="tf-batch" @click="batchGenerateDelivery(data)">批量生成发货单</c-button>
<!--					<c-button color="main" prepend-icon="tf-batch" @click="batchGenerateDelivery(data)">批量生成发货单</c-button>-->
				</template>

				<template #refund_info="{data}">
					<span v-if="!Number(data.refund_amount)">-</span>
					<div v-else class="m-product-info">
						<p style="color: #e53e3e;">{{formatPrice(data.refund_amount)}}</p>
						<p class="m-product-info-code">{{data.refund_date || '-'}}</p>
					</div>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_code" :imei="data.imei"></m-product-info>
				</template>

				<template #order_state="{data}">
					<c-state async dict="SALES_ORDER_STATE" tag :value="getOrderDisplayState(data)"></c-state>
				</template>

				<template #order_info="{data}">
					<div class="m-product-info">
						<p>销售单号：{{data.order_no || '-'}}</p>
						<p class="m-product-info-code">三方订单号：{{data.third_party_order_no || data.order_no || '-'}}</p>
                        <p v-if="data.third_party_quality_code" class="m-product-info-code">三方质检码：{{data.third_party_quality_code}}</p>
					</div>
				</template>

				<template #sale_price="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.sale_price)}}</span>
				</template>

				<template #receiver_info="{data}">
					<div class="m-product-info">
						<p v-if="data.receiver_name">{{data.receiver_name}}（{{data.receiver_phone}}）</p>
						<p v-if="data.receiver_address" class="m-product-info-code">{{data.receiver_address}}</p>
						<p v-if="!data.receiver_name && !data.receiver_address">-</p>
					</div>
				</template>

				<template #settle_state="{data}">
					<c-state async dict="SALE_SETTLE_STATE" :value="data.settle_state"></c-state>
				</template>

				<template #ship_overdue_flag="{data}">
					<span v-if="data.is_overdue_ship == 1" style="color: #e53e3e;">超期</span>
					<span v-else>-</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="160"
					button-limit="6"
				>
					<template #default="{data}">
                        <c-table-button v-if="auth('b_online_order_query')" icon="tf-detail" @click="viewDetail(data)">详情</c-table-button>
                        <c-table-button v-if="auth('b_online_order_ship') && data.order_state == 2  && !data.refuse_type" icon="tf-deliver" @click="openShipDialog(data)">发货</c-table-button>
                        <c-table-button v-if="auth('b_online_order_refuse_ship') && data.order_state == 2 && !(data.channel_id == 11 || data.channel_id == 12) && !data.delivery_no && !data.refuse_type" icon="tf-reject" @click="openRefuseShipDialog(data)">拒绝发货</c-table-button>
						<c-table-button v-if="auth('b_online_order_cancel') && data.order_state == 1" icon="tf-cancel" @click="cancelOrder(data)">取消订单</c-table-button>
					</template>
				</c-table-column>
			</view-list>

			<!-- 批量生成发货单预览弹窗 -->
			<c-dialog ref="batchDeliveryDialog" mode="slide" width="60vw" mask-close enable-flex title="批量生成发货单-预览">
				<div class="m-batch-preview-body">
					<div class="m-batch-preview">
						<div v-for="(group, gIndex) in previewGroups" :key="group.id" class="m-preview-group">
							<div class="m-preview-header">
								<span :class="['m-preview-badge', group.orders.length > 1 ? 'm-merge' : 'm-single']">{{group.orders.length > 1 ? '合并' + group.orders.length + '单' : '独立单'}}</span>
								<span class="m-preview-receiver">{{group.receiverName}} {{group.receiverPhone}}（{{group.receiverAddress}}）</span>
								<span class="m-preview-total">合计：{{group.totalQty}}件</span>
							</div>
							<div class="m-preview-orders">
								<div v-for="(orderItem, oIndex) in group.orders" :key="orderItem.order.id" class="m-preview-order">
									<span class="m-preview-order-text">订单：{{orderItem.order.order_no || '-'}}（{{orderItem.qty}}件）, {{orderItem.productText}}</span>
									<span v-if="group.orders.length > 1" class="m-preview-split" title="拆分不合并" @click="splitOrder(gIndex, oIndex)">
										<i class="tf">&#xe702;</i>
									</span>
								</div>
							</div>
						</div>
						<div v-if="!previewGroups.length" class="m-preview-empty">暂无数据</div>
					</div>

					<div class="m-preview-footer">
						共 {{previewGroups.length}} 组发货单 · 涵盖 {{previewTotalOrders}} 笔订单
					</div>
				</div>

				<template #button>
					<c-button size="dialog" color="main" :disabled="!previewGroups.length" @click="submitBatchDelivery">确认生成发货单</c-button>
					<c-button size="dialog" @click="$refs.batchDeliveryDialog.close()">取消</c-button>
				</template>
			</c-dialog>
		</module>
	</page>
</template>

<script>
	export default {
		data() {
			return {
				previewGroups: [],
				/*********超期未发货提醒是否已检查（进入页面仅提示一次）**********/
				overdueTipChecked: false
			}
		},

		computed: {
			/*********批量预览订单总数**********/
			previewTotalOrders() {
				return this.previewGroups.reduce((sum, group) => sum + group.orders.length, 0);
			}
		},

		methods: {
			/*********视图就绪/切换：进入页面后仅首次检查超期未发货订单**********/
			onViewChange(viewId) {
				if (this.overdueTipChecked) return;
				var currentViewId = viewId || (this.$refs.view && this.$refs.view.getViewId());
				if (!currentViewId) return;
				this.overdueTipChecked = true;
				this.checkOverdueOrderCount(currentViewId);
			},

			/*********查询超期未发货订单数量：存在则弹确认框提醒（需点击确认关闭）**********/
			checkOverdueOrderCount(viewId) {
				this.request({
					url: '/online/sale/overdue/order/count',
					data: {
						view_id: viewId,
						overdue_flag: 1
					},
					response: data => {
						var count = data && data.total ? Number(data.total) : 0;
						if (count <= 0) return;
						this.$confirm({
							message: '有 ' + count + ' 个线上订单已超期未发货，请尽快处理',
							buttonName: '知道了',
							cancelButton: false
						});
					}
				});
			},

			/*********统一显示状态；业务操作仍使用原始 order_state**********/
			getOrderDisplayState(data) {
				const displayState = Number(data.display_state);
				// 后端 getSaleOrderState 的结果包含售后优先级：9售后中、10补差完成、11退机完成。
				if (Number.isInteger(displayState) && displayState >= 1 && displayState <= 11) {
					return displayState;
				}
				// 兼容尚未返回 display_state 的接口；现有字段无法判断售后状态。
				const orderState = Number(data.order_state);
				if (orderState === 2 && Number(data.is_overdue_ship) === 1) return 6;
				if (orderState === 4) {
					if (data.settle_state === 0 || data.settle_state === '0') return 7;
					if (data.settle_state === 1 || data.settle_state === '1') return 8;
				}
				return data.order_state;
			},

			/*********搜索销售渠道**********/
			searchChannel(keyword, resolve) {
				this.request({
					url: '/sale/product/channel/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.channel_name,
								value: item.channel_id
							};
						}));
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********查看详情**********/
			viewDetail(data) {
				this.globalDialog('saleOrderDetail', {
					props: {
						orderType: 2
					},
					data: {
						orderId: data.order_id
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********取消订单**********/
			cancelOrder(data) {
				this.$confirm({
					message: '确认取消订单【' + data.order_no + '】吗？取消后不可恢复',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/online/sale/order/cancel',
							data: {
								order_id: data.order_id,
								cancel_reason: '手动取消'
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg || '取消成功', type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			},



			/*********打开发货弹窗**********/
			openShipDialog(data) {
				this.request({
					url: '/sale/delivery/order/ship/check',
					data: {order_id: data.order_id},
					// loading: true,
					success: () => {
						this.showShipDialog(data);
					},
					fail: (code, result, msg) => {
						this.$confirm({
							message: msg === '订单对应发货单关联多个订单，请通过发货单发货'
								? '该订单所属发货单【'+result+'】关联了多个订单，无法单独发货，请前往[发货单]页面操作。'
								: (msg || '发货校验失败，请重试'),
							buttonName: '我知道了',
							cancelButton: false
						});
						return false;
					}
				});
			},

			showShipDialog(data) {
				this.globalDialog('saleShipDialog', {
					data: {
						orderId: data.order_id,
						deliveryId: data.delivery_id || '',
						orderNo: data.order_no || '',
						productName: this.getProductText(data),
						produceCode: data.produce_code || '',
						channelName: data.channel_name || '',
						qcCode: data.third_party_quality_code || '',
                        providerCode: data.provider_code,
                        waybillType: data.waybill_type,
                        deliveryCompanyCode: data.delivery_company_code,
                        deliveryCompany: data.delivery_company,
                        deliveryExpressNo: data.delivery_express_no
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********打开拒绝发货弹窗**********/
			openRefuseShipDialog(data) {
				this.globalDialog('saleRefuseShipDialog', {
					data: {
						orderId: data.order_id,
						orderNo: data.order_no || '',
						productName: this.getProductText(data),
						produceCode: data.produce_code || '',
						channelName: data.channel_name || ''
					}
				}, () => {
					this.$refs.view.update();
				});
			},

			/*********批量生成发货单**********/
			batchGenerateDelivery(selectedRows) {
				var rows = (selectedRows || []).map(item => item.data || item);
				if (!rows.length) {
					var listRef = this.$refs.view && this.$refs.view.$refs.list;
					rows = (listRef && listRef.getRow('selected') || []).map(item => item.data || item);
				}
				if (!rows.length) {
					this.$message({message: '请先选择订单', type: 'warning'});
					return;
				}

				rows = rows.filter(item => item.order_state == 2 && (!item.delivery_no || item.ship_state == 5));
				if (!rows.length) {
					this.$message({message: '所选订单中暂无待生成发货单订单', type: 'warning'});
					return;
				}

				// 按订单ID聚合，同一订单多行商品合并展示
				var orderMap = {};
				rows.forEach(row => {
					var orderId = row.id;
					if (!orderMap[orderId]) {
						orderMap[orderId] = {
							order: row,
							qty: 0,
							productTexts: []
						};
					}
					orderMap[orderId].qty += 1;
					var text = this.getProductText(row);
					if (text && text != '-' && orderMap[orderId].productTexts.indexOf(text) == -1) {
						orderMap[orderId].productTexts.push(text);
					}
				});

				var orderItems = [];
				for (var key in orderMap) {
					var item = orderMap[key];
					orderItems.push({
						order: item.order,
						qty: item.qty,
						productText: item.productTexts.join(' | ') || '-'
					});
				}

				// 按收货人+手机号+地址合并
				var groups = [];
				orderItems.forEach(item => {
					var groupKey = [item.order.receiver_name, item.order.receiver_phone, item.order.receiver_address].join('|');
					var group = groups.find(g => g.key == groupKey);
					if (!group) {
						group = {
							id: groups.length + 1,
							key: groupKey,
							receiverName: item.order.receiver_name || '-',
							receiverPhone: item.order.receiver_phone || '-',
							receiverAddress: item.order.receiver_address || '-',
							orders: [],
							totalQty: 0
						};
						groups.push(group);
					}
					group.orders.push(item);
					group.totalQty += item.qty;
				});

				this.previewGroups = groups;
				this.$refs.batchDeliveryDialog.open();
			},

			/*********拆分订单（不合并）**********/
			splitOrder(groupIndex, orderIndex) {
				var group = this.previewGroups[groupIndex];
				var orderItem = group.orders.splice(orderIndex, 1)[0];
				group.totalQty -= orderItem.qty;
				if (!group.orders.length) {
					this.previewGroups.splice(groupIndex, 1);
				}
				this.previewGroups.push({
					id: Date.now(),
					key: [orderItem.order.receiver_name, orderItem.order.receiver_phone, orderItem.order.receiver_address].join('|'),
					receiverName: orderItem.order.receiver_name || '-',
					receiverPhone: orderItem.order.receiver_phone || '-',
					receiverAddress: orderItem.order.receiver_address || '-',
					orders: [orderItem],
					totalQty: orderItem.qty
				});
			},

			/*********确认批量生成发货单**********/
			submitBatchDelivery() {
				if (!this.previewGroups.length) {
					this.$message({message: '没有可生成的发货单', type: 'warning'});
					return;
				}

				var deliveryGroups = this.previewGroups.map(group => {
					return {
						receiver_name: group.receiverName,
						receiver_phone: group.receiverPhone,
						receiver_address: group.receiverAddress,
						order_ids: group.orders.map(item => item.order.order_id)
					};
				});

				this.request({
					url: '/sale/delivery/batch/generate',
					data: {
                        deliveries: JSON.stringify(deliveryGroups)
					},
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || '生成发货单成功', type: 'success'});
						this.$refs.batchDeliveryDialog.close();
						this.$refs.view.update();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}

		.m-product-info-code {
			color: #999;
			font-size: 12px;
		}
	}

	// 批量生成发货单预览
	.m-batch-preview-body {
		display: flex;
		flex-direction: column;
		height: 100%;
	}

	.m-batch-preview {
		flex: 1;
		overflow-y: auto;
		min-height: 0;
		padding-right: 4px;

		.m-preview-group {
			background: #f7f8fa;
			border-radius: 4px;
			padding: 12px 16px;
			margin-bottom: 12px;

			.m-preview-header {
				display: flex;
				align-items: center;
				gap: 8px;
				margin-bottom: 10px;

				.m-preview-badge {
					padding: 2px 6px;
					border-radius: 2px;
					font-size: 12px;
					color: #fff;

					&.m-merge {
						background: #3D5EFF;
					}

					&.m-single {
						background: #07B461;
					}
				}

				.m-preview-receiver {
					flex: 1;
					font-size: 13px;
					color: #333;
					word-break: break-all;
				}

				.m-preview-total {
					font-size: 13px;
					color: #666;
					white-space: nowrap;
				}
			}

			.m-preview-orders {
				display: flex;
				flex-wrap: wrap;
				gap: 10px;

				.m-preview-order {
					background: #fff;
					border: 1px solid #e5e5e5;
					border-radius: 4px;
					padding: 6px 10px;
					display: flex;
					align-items: center;
					gap: 8px;
					font-size: 12px;
					color: #333;

					.m-preview-order-text {
						word-break: break-all;
					}

					.m-preview-split {
						color: #3D5EFF;
						cursor: pointer;
						display: inline-flex;
						align-items: center;
						flex-shrink: 0;

						i {
							font-size: 14px;
							font-style: normal;
						}

						&:hover {
							color: #5F7FFF;
						}
					}
				}
			}
		}

		.m-preview-empty {
			text-align: center;
			color: #999;
			padding: 30px 0;
			font-size: 13px;
		}
	}

	.m-preview-footer {
		margin-top: 16px;
		font-size: 13px;
		color: #666;
	}
</style>
